import clsx from 'clsx';
import React from 'react';

import s from './shared.module.less';

export const VL: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div {...rest} className={clsx(s.vl, className)} />
);
